import { Button, Theme } from "@mui/material";
import * as React from "react";
import styled from "@mui/material/styles/styled";
import { GenderValue } from "shared";
import { PatientColorMap } from "../../layout/patientColorMap";
import { CHAT_ELEMENT_HEIGHT } from "../consts/sizeConsts";
import { useTranslate } from "../../hooks/useTranslate";
import clsx from "clsx";

//region [[ Styles ]]

export const AnswerButtonView = styled(Button)(
  ({ theme, answered }: { theme?: Theme; answered: "true" | "false" }) => ({
    "&.answer-button": {
      boxShadow: "unset",
      color: answered === "true" ? "white" : PatientColorMap.Default,
      backgroundColor:
        answered === "true"
          ? PatientColorMap.Selected
          : PatientColorMap.Unselected,
      border: "unset",
      margin: "0 3px",
      minHeight: CHAT_ELEMENT_HEIGHT,
      borderRadius: "30px",
      minWidth: "80px",
      lineHeight: 1.3,
      "&:focus, &:hover, &:active": {
        color: answered === "true" ? "white" : PatientColorMap.Default,
        backgroundColor:
          answered === "true"
            ? PatientColorMap.Selected
            : PatientColorMap.Unselected,
      },
      "&.disabled": {
        color: answered === "true" ? "white" : PatientColorMap.Default,
        backgroundColor:
          answered === "true"
            ? PatientColorMap.Selected
            : PatientColorMap.Unselected,
      },
    },
  }),
);

export const ButtonContents = styled("div")(({ theme }: { theme?: Theme }) => ({
  display: "flex",
  flexDirection: "row",
  width: "100%",
}));

export const BottomPart = styled("div")(
  ({ theme, center }: { theme?: Theme; center: "true" | "false" }) => ({
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: center ? "center" : "space-between",
  }),
);

export const AnswerText = styled("div")({
  fontWeight: 500,
  textTransform: "lowercase",
  "&:first-letter": {
    textTransform: "uppercase",
  },
  fontSize: "15px",
  marginTop: "2px",
  whiteSpace: "nowrap",
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface AnswerButtonProps {
  className?: string;
  selected?: boolean;
  onClick: () => void;
  gender: GenderValue;
  type: SelectionType;
}

//endregion [[ Props ]]

//region [[ Functions ]]

export enum SelectionType {
  YES,
  NO,
  DONT_KNOW,
}

//endregion [[ Functions ]]

export const AnswerButton = ({ ...props }: AnswerButtonProps) => {
  const { translate } = useTranslate();

  return (
    <AnswerButtonView
      className={clsx(props.className, "answer-button")}
      answered={props.selected ? "true" : "false"}
      variant={"outlined"}
      onClick={props.onClick}
    >
      <ButtonContents>
        <BottomPart center={props.gender ? "true" : "false"}>
          <AnswerText>
            {props.type === SelectionType.YES
              ? translate("ANSWER_YES")
              : props.type === SelectionType.NO
              ? translate("ANSWER_NO")
              : translate("ANSWER_SKIP")}
          </AnswerText>
        </BottomPart>
      </ButtonContents>
    </AnswerButtonView>
  );
};
